import api from "../../core/api";
import { ChangeManufacturer, Manufacturer } from "../models/AdminProductsModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.catalogApiBaseUrl };
}

class AdminManufacturersApi {
  getManufacturers(): Promise<Manufacturer[]> {
    return api.get<Manufacturer[]>(`/v1/admin/manufacturers`, getRequestConfig()).then(x => x.data);
  }

  createManufacturer(model: ChangeManufacturer): Promise<void> {
    return api.post('/v1/admin/manufacturers', model, getRequestConfig());
  }

  changeManufacturer(id: string, manufacturer: ChangeManufacturer): Promise<any> {
    return api.put(`/v1/admin/manufacturers/${id}`, manufacturer, getRequestConfig());
  }
}

export default new AdminManufacturersApi();